import { Component, Input } from '@angular/core';
import { PatientBehaviorConsequenceModel } from '../../../../core/api/models';
import { StaffApiService } from '../../../../core/api/services';
import { SupervisorHelperService } from '../../../supervisor.helper.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { Utils } from '../../../../core/utils';

@Component({
  selector: 'app-consequence',
  templateUrl: './consequence.component.html',
  standalone: false,
})
export class ConsequenceComponent {
  @Input() consequence: PatientBehaviorConsequenceModel | undefined;

  constructor(
    private staffApiService: StaffApiService,
    private supervisorHelperService: SupervisorHelperService,
    private alertService: AlertService
  ) {}

  isCollapsed = true;

  toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed;
  }

  editConsequence() {
    console.log('editConsequence clicked!');
    this.supervisorHelperService.addConsequenceButtonClicked(
      this.consequence ?? null
    );
  }

  restoreConsequence() {
    if(this.consequence?.ID != null){
      this.staffApiService
      .RestoreConsequence({ id: this.consequence?.ID ?? 0 })
      .subscribe(() => {
        this.alertService.success('consequence restored');
        this.supervisorHelperService.triggerUpdateSignal();
      });
    }
  }
  deleteConsequence() {
    console.log('deleteConsequence clicked!');

    this.alertService
      .confirm(
        'Delete Consequence',
        'Are you sure you want to delete this consequence?'
      )
      .subscribe((result) => {
        if (result) {
          this.deleteConsequenceConfirmed();
        }
      });
  }

  deleteConsequenceConfirmed() {
    if (this.consequence?.ID != null) {
      this.staffApiService
        .MarkConsequenceAsDeleted({
          id: this.consequence.ID,
        })
        .subscribe(
          () => {
            this.alertService.success('Consequence marked as deleted');
            this.supervisorHelperService.triggerUpdateSignal();
          },
          (error) => {
            this.alertService.error(
              Utils.getErrorMessageFromErrorResponse(error)
            );
          }
        );
    }
  }
}
